import { ColumnConfig, WabaUserReportColumnKey } from '../model';

export const wabaUserReportConfig: Record<
  WabaUserReportColumnKey,
  ColumnConfig
> = {
  sNo: {
    name: 'S.no',
  },
  principal: {
    name: 'Principal',
  },
  wabaphonenumber: {
    name: 'WABA Phone Number',
  },
  wabaId: {
    name: 'WABA ID',
  },
  projectId: {
    name: 'Project ID',
  },
  // projectName: {
  //   name: 'Project Name',
  // },
  currentVersion: {
    name: 'Current Version',
  },
  // newVersion: {
  //   name: 'New Version',
  // },
  action: {
    name: 'Actions',
  },
};
